module.exports = __webpack_public_path__ + "static/media/flag_jp.5edff571.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/flashcard/flag_jp.svg
// module id = 130
// module chunks = 0